export default __webpack_public_path__ + "static/media/jyg.8ac6c59a.png";